@if (!utils.isCollectionNullOrEmpty(cmcdPlcList)) {
  <div @triggerPeriode>

    <dx-toolbar class="yo-toolbar">
      <dxi-item location="before">
        <div class="d-flex flex-row align-items-center font-12">
          <i class="fas fa-map-pin mg-r-5 pn-border-color"></i>
          <span class="mg-r-5">
            {{ pointDeLivraison.libelle | uppercase }}
            - <span [innerHTML]="sanitizer.bypassSecurityTrustHtml(cmcMnSvc.getPeriodeLabelHTML(periode))"></span>
          </span>
          <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
        </div>
      </dxi-item>

      <dxi-item location="after">
        <div class="d-flex flex-row align-items-center">
          <dx-drop-down-button
            class="mg-r-5"
            icon="fas fa-edit"
            hint="Modification en masse des effectifs, coûts et taux de prise théoriques"
            displayExpr="label"
            [showArrowIcon]="false"
            [dropDownOptions]="{ width: 200 }"
            [items]="editPlanningItemList"
            (onItemClick)="onEditPlanningItemClick($event)">
          </dx-drop-down-button>

          <yo-button
            tooltip="Enregistrer"
            iconClass="fas fa-save"
            [theme]="ButtonThemeEnum.SUCCESS"
            [disabled]="!gds.canModify(contratMenuConvive)"
            (onClick)="savePlanning()">
          </yo-button>
        </div>
      </dxi-item>
    </dx-toolbar>

    <!--    GRILLE DES EFFECTIFS-->
    <dx-data-grid
      class="yo-planning-plc-grid"
      [dataSource]="rows"
      keyExpr="id"
      [height]="utils.scrollHeightContent(230)"
      width="100%"
      [showBorders]="true"
      [showRowLines]="true"
      [showColumnLines]="true"
      [hoverStateEnabled]="false"
      [allowColumnResizing]="true"
      [columnAutoWidth]="true"
      (onCellPrepared)="onCellPrepared($event)">

      <dxo-paging [enabled]="false"></dxo-paging>
      <dxo-scrolling mode="standard"></dxo-scrolling>
      <dxo-sorting mode="none"></dxo-sorting>

      <!--COLONNES FIGEES-->
      <dxi-column name="jour" caption="Jour"
                  [fixed]="true" fixedPosition="left" cellTemplate="tplJour"></dxi-column>

      <dxi-column name="repas" caption="Repas"
                  [fixed]="true" fixedPosition="left" cellTemplate="tplRepas"></dxi-column>

      <dxi-column name="regime" caption="Régime"
                  [fixed]="true" fixedPosition="left" cellTemplate="tplRegime"></dxi-column>

      <dxi-column name="effectifPrev" caption="Effectif prév."
                  [fixed]="true" fixedPosition="left" cellTemplate="tplEffectifPrev"></dxi-column>

      <dxi-column name="coutPrev" caption="Coût prév."
                  [fixed]="true" fixedPosition="left" cellTemplate="tplCoutPrev"></dxi-column>

      <!--UNE COLONNE PAR DECOUPAGE REPAS-->
      @for (decoupageColumn of decoupageColumnList; track decoupageColumn.name) {
        <dxi-column
          [name]="decoupageColumn.name"
          [caption]="decoupageColumn.caption"
          [calculateCellValue]="decoupageColumn.calculateCellValue"
          cellTemplate="tplCellDecoupage"
          headerCellTemplate="tplHeaderDecoupage"></dxi-column>
      }

      <!--ENTETE DECOUPAGE REPAS-->
      <div *dxTemplate="let header of 'tplHeaderDecoupage'">
        <div class="no-overflow" [title]="header.column.caption">{{ header.column.caption }}</div>
      </div>

      <!--JOUR-->
      <div *dxTemplate="let cell of 'tplJour'">
        <div class="cell-stack" [style.min-height.px]="getTailleComposante(cell.data)">
          @if (isFirstRowOfJour(cell.data)) {
            <div class="cell-line">
              <dx-check-box
                hint="Ouvrir / fermer tous les repas et régimes de ce jour"
                [value]="getJourCheckValue(cell.data)"
                (onValueChanged)="onJourCheckChange(cell.data, $event)">
              </dx-check-box>
              <strong class="cell-text">{{ utils.getJourSemaineById(cell.data.idJourSemaine).viewValue | uppercase }}</strong>
            </div>
          }
        </div>
      </div>

      <!--REPAS-->
      <div *dxTemplate="let cell of 'tplRepas'">
        <div class="cell-stack" [style.min-height.px]="getTailleComposante(cell.data)">
          <div class="cell-line" [title]="cell.data.repasLibelle">
            <dx-check-box
              hint="Ouvrir / fermer tous les régimes de ce repas"
              [value]="getRepasCheckValue(cell.data)"
              (onValueChanged)="onRepasCheckChange(cell.data, $event)">
            </dx-check-box>
            <strong class="cell-text">{{ cell.data.repasLibelle }}</strong>
          </div>
        </div>
      </div>

      <!--REGIME-->
      <div *dxTemplate="let cell of 'tplRegime'">
        <div class="cell-stack" [style.min-height.px]="getTailleComposante(cell.data)">
          @for (item of getAllCmcrCmcCaPlc(cell.data); track item) {
            <div class="cell-line" [title]="item.libelleRegime">
              <dx-check-box
                hint="Ouvrir / fermer ce régime"
                [(ngModel)]="item.actif">
              </dx-check-box>
              <strong class="cell-text" [class.regime-ferme]="!item.actif">{{ item.libelleRegime }}</strong>
            </div>
          }
        </div>
      </div>

      <!--EFFECTIF PREVISIONNEL-->
      <div *dxTemplate="let cell of 'tplEffectifPrev'">
        <div class="cell-stack" [style.min-height.px]="getTailleComposante(cell.data)">
          @for (item of getAllCmcrCmcCaPlc(cell.data); track item) {
            <div class="cell-line">
              <yo-number-box class="cell-input"
                             title="Effectif prévisionnel"
                             [min]="0"
                             [disabled]="!item.actif"
                             [value]="item.effectifPrevisionnel"
                             (onValueChanged)="item.effectifPrevisionnel = +$event">
              </yo-number-box>
              <span class="cell-unit">pers.</span>
            </div>
          }
        </div>
      </div>

      <!--COUT PREVISIONNEL-->
      <div *dxTemplate="let cell of 'tplCoutPrev'">
        <div class="cell-stack" [style.min-height.px]="getTailleComposante(cell.data)">
          @for (item of getAllCmcrCmcCaPlc(cell.data); track item) {
            <div class="cell-line">
              <yo-number-box class="cell-input"
                             title="Coût prévisionnel"
                             [min]="0"
                             [disabled]="!item.actif"
                             [value]="item.coutPrevisionnel"
                             (onValueChanged)="item.coutPrevisionnel = +$event">
              </yo-number-box>
              <span class="cell-unit">€</span>
            </div>
          }
        </div>
      </div>

      <!--TAUX DE PRISE PAR PLAT (saisie de l'effectif previsionnel en % pour un jour/repas/decoupage/plat)-->
      <div *dxTemplate="let cell of 'tplCellDecoupage'">
        <div class="cell-stack" [style.min-height.px]="getTailleComposante(cell.data)">
          @if (cell.value) {
            @for (slot of utils.getSlots(cell.value.nombreChoixMaximum); track slot) {
              @let cmcdPlc = getCmcdPlc(cell.value, slot + 1);
              @if (cmcdPlc) {
                <div class="cell-line">
                  <span class="cell-label">Plat {{ cmcdPlc.ordre }}</span>
                  <yo-number-box class="cell-input"
                                 title="Taux de prise"
                                 [min]="0"
                                 [disabled]="isRepasFerme(cell.data)"
                                 [value]="cmcdPlc.tauxDePrise"
                                 (onValueChanged)="cmcdPlc.tauxDePrise = +$event">
                  </yo-number-box>
                  <span class="cell-unit">%</span>
                  @if (cmcdPlc.arrondiEffPrev) {
                    <yo-icon
                      class="cursor mg-l-5"
                      icon="fa-exclamation-triangle"
                      size="small"
                      [theme]="IconThemeEnum.ERROR_INNER"
                      title="Arrondi réalisé pour que la somme des plats corresponde à l'effectif prévisionnel du jour / repas ."></yo-icon>
                  }
                </div>
              }
            }
          }
        </div>
      </div>

    </dx-data-grid>

  </div>
}

<!--DIALOG EFFECTIFS PREV-->
<yo-dialog-update-effectifs
  [(visible)]="displayEffectifDialog"
  mode="effectif"
  [repasList]="repasList"
  [joursSemaine]="joursSemaine"
  [cmcrCmcCaPlcList]="cmcrCmcCaPlcList"
></yo-dialog-update-effectifs>

<!--DIALOG COUT THEORIQUE-->
<yo-dialog-update-effectifs
  [(visible)]="displayCoutDialog"
  mode="cout"
  [repasList]="repasList"
  [joursSemaine]="joursSemaine"
  [cmcrCmcCaPlcList]="cmcrCmcCaPlcList"
></yo-dialog-update-effectifs>

<!--DIALOG TAUX DE PRISE PREV-->
<yo-dialog-update-taux-prise
  [(visible)]="displayTauxDePriseDialog"
  [joursSemaine]="joursSemaine"
  [repasList]="repasList"
  [decoupageRepasList]="decoupageRepasList"
  [platList]="platList"
  [rows]="rows"
  [cells]="cells"
  [cmcdPlcList]="cmcdPlcList"
></yo-dialog-update-taux-prise>
